import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OfferList from './pages/OfferList';
import CreateOffer from './pages/CreateOffer';
import OfferDetail from './pages/OfferDetail';
import EditOffer from './pages/EditOffer';
import EditOfferScope from './pages/EditOfferScope';
import PrivateRoute from './components/PrivateRoute';
import Customers from './pages/Customers';
import PendingOffers from './pages/PendingOffers';
import Products from './pages/Products';
import Users from './pages/Users';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/offers" element={<PrivateRoute><OfferList /></PrivateRoute>} />
        <Route path="/offers/create" element={<PrivateRoute><CreateOffer /></PrivateRoute>} />
        <Route path="/offers/:id" element={<PrivateRoute><OfferDetail /></PrivateRoute>} />
        <Route path="/offers/:id/edit" element={<PrivateRoute><EditOffer /></PrivateRoute>} />
        <Route path="/offers/:id/scope" element={<PrivateRoute><EditOfferScope /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="/pending-offers" element={<PrivateRoute><PendingOffers /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
